// Zustand Store
import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { User, SignedInUser } from "../types/auth";
import { getUserAccount } from "../utils/auth";

interface AuthStore {
  user: SignedInUser | null;
  token: string | null;
  isAuthenticated: boolean;
  setAuth: (auth: SignedInUser | null) => void;
  clearAuth: () => void;
  updateUser: (updates: Partial<User>) => void;
}

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      user: getUserAccount(),
      token: null,
      isAuthenticated: false,
      setAuth: (auth) =>
        set({
          user: auth,
          token: auth?.token,
          isAuthenticated: !!auth,
        }),
      clearAuth: () =>
        set({
          user: null,
          token: null,
          isAuthenticated: false,
        }),
      updateUser: (updates) =>
        set((state) => ({
          user: state.user ? { ...state.user, ...updates } : null,
        })
      ),
    }),
    {
      name: "auth-storage",
      partialize: (state) => ({
        user: state.user,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);
